// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__31H_X","question":"Question_question__1l7hV","description":"Question_description__1dDpt"};